@import '~style-sheet-helpers/core.less';

.title {
  margin: 24px 0 12px;
  font-weight: @normal;
}

.title-text {
  margin-right: 4px;
}

.description {
  margin: 12px 0;
}

.inline-message-container {
  display: inline-block;
  margin-bottom: 8px;
}

.yAxis-label {
  font-size: 14px;
  text-anchor: middle;
}
